import React, { useEffect, useMemo, useState } from 'react';
import { motion } from 'framer-motion';

const CodeAnimation = () => {
  const [currentLine, setCurrentLine] = useState(0);
  const [displayedCode, setDisplayedCode] = useState('');

  const codeLines = useMemo(() => [
  'const developer = {',
    '  name: "Golam Sarwar",',
    '  role: "Full Stack Developer",',
    '  skills: ["React", "Node.js", "TypeScript"],',
    '  passion: "Building amazing experiences"',
    '};',
    '',
    'while (learning) {',
    '  developer.skills.push(newTech);',
    '  createAwesomeProjects();',
    '}',
    '',
    '// Ready to build something incredible?',
    'developer.contact();'
], []);

  useEffect(() => {
    if (currentLine < codeLines.length) {
      const timer = setTimeout(() => {
        setDisplayedCode(prev => prev + codeLines[currentLine] + '\n');
        setCurrentLine(prev => prev + 1);
      }, 100 + Math.random() * 200);
      return () => clearTimeout(timer);
    }
  }, [currentLine, codeLines]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="glass card p-6 rounded-xl border border-purple-500/20 max-w-2xl mx-auto my-16"
    >
      <div className="flex items-center gap-3 mb-4">
        <div className="flex gap-2">
          <div className="w-3 h-3 bg-red-500 rounded-full"></div>
          <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
        </div>
        <span className="text-gray-400 text-sm">developer.js</span>
      </div>

      <pre className="text-green-400 font-mono text-sm overflow-hidden">
        <code>
          {displayedCode}
          <span className="animate-pulse text-purple-400">|</span>
        </code>
      </pre>
    </motion.div>
  );
};

export default CodeAnimation;